import { render, staticRenderFns } from "./category-big.vue?vue&type=template&id=543ed83d&scoped=true"
import script from "./category-big.vue?vue&type=script&lang=js"
export * from "./category-big.vue?vue&type=script&lang=js"
import style0 from "./category-big.vue?vue&type=style&index=0&id=543ed83d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543ed83d",
  null
  
)

export default component.exports